'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.groupby');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ = require('..');

var _2 = require('.');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventList = function (_Component) {
  (0, _inherits3.default)(EventList, _Component);

  function EventList(props) {
    (0, _classCallCheck3.default)(this, EventList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventList.__proto__ || (0, _getPrototypeOf2.default)(EventList)).call(this));

    _moment2.default.locale(props.locale);
    return _this;
  }

  (0, _createClass3.default)(EventList, [{
    key: 'getListItems',
    value: function getListItems(events) {
      var transferableProps = {
        dateFormat: this.props.dateFormat,
        layout: this.props.layout,
        placeholderImage: this.props.placeholderImage,
        size: this.props.size
      };

      if (this.props.template) {
        var template = this.props.template;

        return events.map(function (event) {
          return _react2.default.createElement(
            _2.EventListItem,
            (0, _extends3.default)({ key: event.id + '-' + (0, _moment2.default)(event.next_date || event.start_date).format('YYYYMMDD'), event: event }, transferableProps),
            _react2.default.createElement(
              'div',
              null,
              template(event)
            )
          );
        });
      }

      return events.map(function (event) {
        return _react2.default.createElement(_2.EventListItem, (0, _extends3.default)({ key: event.id + '-' + (0, _moment2.default)(event.next_date || event.start_date).format('YYYYMMDD'), event: event }, transferableProps));
      });
    }
  }, {
    key: 'eventList',
    value: function eventList() {
      var _this2 = this;

      var _props = this.props,
          currentPage = _props.currentPage,
          events = _props.events,
          pageChange = _props.pageChange,
          totalPages = _props.totalPages;

      var groupByFormat = this.props.groupBy === 'week' ? 'ggggww' : 'YYYYMMDD';
      var eventList = void 0;

      if (this.props.groupBy === 'none') {
        eventList = this.getListItems(events);
      } else {
        var sections = (0, _lodash2.default)(events, function (event) {
          return (0, _moment2.default)(event.next_date || event.start_date).format(groupByFormat);
        });

        eventList = (0, _keys2.default)(sections).map(function (section) {
          var sectionDay = (0, _moment2.default)(section, groupByFormat);
          return _react2.default.createElement(
            'section',
            { key: section },
            _react2.default.createElement(
              'header',
              null,
              _react2.default.createElement(
                'time',
                { dateTime: sectionDay.format('YYYY-MM-DD') },
                _this2.props.groupBy === 'week' && (0, _i18n2.default)('weekOf') + ' ',
                sectionDay.format('Do MMMM')
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _this2.getListItems(sections[section])
            )
          );
        });
      }

      if (currentPage && totalPages > 1) {
        eventList.push(_react2.default.createElement(_2.Pagination, { key: 'pagination', action: pageChange, currentPage: currentPage, totalPages: totalPages }));
      }

      return eventList;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          beforeFilters = _props2.beforeFilters,
          beforeEvents = _props2.beforeEvents,
          className = _props2.className,
          clearFilters = _props2.clearFilters,
          emptyMessage = _props2.emptyMessage,
          events = _props2.events,
          filters = _props2.filters,
          removeFilter = _props2.removeFilter,
          title = _props2.title;


      var message = emptyMessage || (0, _i18n2.default)('noEvents');
      var classes = (0, _utils.classNames)('EventList', className, (_classNames = {}, (0, _defineProperty3.default)(_classNames, 'columns-' + this.props.columns + ' container-' + this.props.container, this.props.layout === 'grid'), (0, _defineProperty3.default)(_classNames, 'loading', this.props.loading), _classNames));
      var hasEvents = events && events.length > 0;

      return _react2.default.createElement(
        'div',
        { className: classes },
        title && _react2.default.createElement(
          'h2',
          null,
          title
        ),
        beforeFilters,
        _react2.default.createElement(_2.ActiveFilters, { key: 'filters', selected: filters, action: removeFilter, clear: clearFilters }),
        beforeEvents,
        hasEvents ? _react2.default.createElement(
          'div',
          { className: 'events' },
          this.eventList()
        ) : _react2.default.createElement(
          'p',
          { className: 'empty' },
          message
        )
      );
    }
  }]);
  return EventList;
}(_react.Component);

EventList.propTypes = {
  /**
   * Content to be appended before ActiveFilters
   */
  beforeFilters: _propTypes2.default.element,
  /**
   * Content to be appended before the event list
   */
  beforeEvents: _propTypes2.default.element,
  /**
   * A CSS class to be appended to the default list of classes
   */
  className: _propTypes2.default.string,
  /**
   * Function to call when all filters are cleared
   */
  clearFilters: _propTypes2.default.func,
  /**
   * Number of grid columns when using the `grid` layout.
   */
  columns: _propTypes2.default.number,
  /**
   * Total number of columns in the container when using the `grid` layout.
   */
  container: _propTypes2.default.number,
  /**
   * Current page number
   */
  currentPage: _propTypes2.default.number,
  /**
   * [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date and
   * time. Can include markup.
   */
  dateFormat: _propTypes2.default.string,
  /**
   * The message to display when there are no events.
   */
  emptyMessage: _propTypes2.default.string,
  /**
   * Array of event objects in the Caligram API format.
   */
  events: _propTypes2.default.array,
  /**
   * Currently active filters.
   */
  filters: _propTypes2.default.array,
  /**
   * Groups events into `&lt;section&gt;`s based on event dates.
   */
  groupBy: _propTypes2.default.oneOf(['week', 'day', 'none']),
  /**
   * Display events in a linear list or as a grid.
   */
  layout: _propTypes2.default.oneOf(['list', 'grid']),
  /**
   * Whether the events are currently loading
   */
  loading: _propTypes2.default.bool,
  /**
   * [Moment](https://momentjs.com/docs/#/i18n/) locale string
   */
  locale: _propTypes2.default.string,
  /**
   * Function to call when changing page.
   */
  pageChange: _propTypes2.default.func,
  /**
   * Placeholder image to be used when the event has no image.
   */
  placeholderImage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  /**
   * Function to call when a filter is removed
   */
  removeFilter: _propTypes2.default.func,
  /**
   * Template for children events. A method that takes an event and returns React elements
   */
  template: _propTypes2.default.func,
  /**
   * Display size of the events. Only used for the grid layout.
   */
  size: _propTypes2.default.oneOf(['small', 'normal']),
  /**
   * Optional title to display above the list
   */
  title: _propTypes2.default.string,
  /**
   * Total number of pages
   */
  totalPages: _propTypes2.default.number
};
EventList.defaultProps = {
  columns: 3,
  container: 12,
  groupBy: 'day',
  layout: 'list',
  locale: _.CaligramReact.config().locale,
  size: 'normal'
};
exports.default = EventList;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventList.js
// module id = 270
// module chunks = 0